import DimensionPreview from "./DimensionPreview";

export default DimensionPreview;
